import { format } from "date-fns"
import { sanitizeZipcode } from "../sanitizeZipcode"

export const normalizeParams = (values, vendorId, mode, selectedUn, laneDistance) => {
    const data = values

    // const numbersForInsuranceAmout = data?.insuranceAmount ? data?.insuranceAmount : ''
    // const highestInsuranceAmount = Math?.max(...numbersForInsuranceAmout)
    // const highestInsuranceAmount = numbersForInsuranceAmout
    // const indexOfHighest = numbersForInsuranceAmout?.indexOf(highestInsuranceAmount)

    return {
        'rateTypesList[]': mode?.code === 'DRAY' ? 'DRAY' : '',
        vendorId: vendorId,
        originCity: data.shipper.city,
        originState: data.shipper.state,
        originIATA: data.shipper.IATACode,
        destinationIATA: data.consignee.IATACode,
        originZipcode: sanitizeZipcode(data.shipper.zipcode),
        originCountry: data.shipper.country == 'Port' ? 'US' : data.shipper.country,
        origin_IATACode: data.shipper.origin_IATACode,
        destinationCity: data.consignee.city,
        destinationState: data.consignee.state,
        destinationZipcode: sanitizeZipcode(data.consignee.zipcode),
        destinationCountry: data.consignee.country === 'USA' ? 'US' : data.consignee.country,
        destination_IATACode: data.consignee.origin_IATACode,
        freightInfo: JSON.stringify(
            data.freightInfo.map((freight, index) => {
                let selectedUnIndex = selectedUn?.filter(s => s.index === index)[0]
                return mode?.shipmentCategory === 'Drayage' ? {
                    qty: parseFloat(freight.qty),
                    weight: parseFloat(freight.weight),
                    weightType: "each",
                    length: 1,
                    width: 1,
                    height: 1,
                    class: 0,
                    volume: freight.volume,
                    dimTypeDrayage: freight.container,
                    freightsnapId: freight.freightsnapId || null,
                    hazmat: freight.hazmat,
                    stack: false,
                    overweight: freight.freightInfoAccessorials?.includes('Overweight'),
                    reefer: freight.freightInfoAccessorials?.includes('Reefer'),
                    residentialDelivery: freight.freightInfoAccessorials?.includes('Residential Delivery'),
                    householdGoods: freight.freightInfoAccessorials?.includes('Household Goods'),
                    liquor: freight.freightInfoAccessorials?.includes('Liquor'),
                    storageYard: freight.freightInfoAccessorials?.includes('Storage Yard'),
                    CYDepot: freight.freightInfoAccessorials?.includes('CY/Depot'),
                    UN: freight?.UN,                    
                    UNDescription: selectedUnIndex?.description,
                    UNHAZClass:  selectedUnIndex?.HAZClass,
                    UNPKGGroup: selectedUnIndex?.PKGGroup,
                    UNLabels: selectedUnIndex?.labels,
                } : {
                    qty: parseFloat(freight.qty),
                    weight: parseFloat(freight.weight),
                    weightType: freight.each === "Each" ? "each" : "total",
                    length: parseFloat(freight.L) || 0,
                    width: parseFloat(freight.W) || 0,
                    volume: freight.volume,
                    height: parseFloat(freight.H) || 0,
                    class: parseFloat(freight.class) || 0,
                    hazmat: freight.hazmat,
                    commodity: freight.commodity,
                    freightsnapId: freight.freightsnapId || null,
                    dimType: freight.dimType.value,
                    nmfc: freight.nmfc,
                    UN: freight?.UN,                    
                    UNDescription: selectedUnIndex?.description,
                    UNHAZClass:  selectedUnIndex?.HAZClass,
                    UNPKGGroup: selectedUnIndex?.PKGGroup,
                    UNLabels: selectedUnIndex?.labels,
                    stack: (freight.stack === 'No' || !freight.stack) ? false : true,
                    stackAmount: (freight.stack === 'No' || !freight.stack) ? null : parseInt(freight.stack),
                }
            })
        ),
        UOM: data.freightInfoUOM.value,
        'accessorialsList[]': [
            ...data.accessorials.origin.map(acc => acc.code),
            ...data.accessorials.destination.map(acc => acc.code),
            ...data.accessorials.other.map(acc => acc.code)
        ].join('|'),
        pickupDate: format(data.pickupDate.date, "yyyy-MM-dd"),
        laneDistance: laneDistance ?? data.laneDistance,
        commodityInsurance: data?.commodityInsurance ? data?.commodityInsurance : null,
        insuranceAmount: data.insuranceAmount ? data.insuranceAmount : null,
        insuranceFreight: data?.insuranceFreight ? data?.insuranceFreight : false,
        insuranceAddOn: data?.insuranceAddOn ? data?.insuranceAddOn : false,
        redkikQuoteId: data.redkikQuoteId ? data.redkikQuoteId : null,
        coverTypeInsurance: data?.coverTypeInsurance ? data?.coverTypeInsurance : null,
    }
}